import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAnalytics, isSupported, logEvent, setUserProperties, type Analytics } from "firebase/analytics";
import { APP_VERSION, BUILD_NUMBER } from '../config';
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  bobJames: "This is a test string to ensure that the API key is not exposed in logs or error messages.",
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: "https://mobidawg-native-db-default-rtdb.firebaseio.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: "G-1D4PEXW6RV"
};


{/*  VITE_FIREBASE_API_KEY  */}
console.log("Firebase configuration:", ("ABCDEF" + firebaseConfig.apiKey).slice(-6));
console.log("Firebase configuration:", firebaseConfig.authDomain);
console.log("Firebase configuration:", firebaseConfig.projectId);
console.log("Firebase configuration:", firebaseConfig.storageBucket);
console.log("Firebase configuration:", firebaseConfig.messagingSenderId);
console.log("Firebase configuration:", firebaseConfig.appId);
// Initialize Firebase
const app = initializeApp(firebaseConfig);


if (import.meta.env.DEV) {
  // @ts-ignore
  self.FIREBASE_APPCHECK_EXECUTE_IN_DEBUG_MODE = true;
}

//  provider: new ReCaptchaV3Provider(import.meta.env.VITE_RECAPTCHA_SITE_KEY || process.env.AppCheck_Recaptcha_SiteKey || '6LeTgYYtAAAAAOFPbgVcQQdbNyDfbcBEXmPaRae0'),

const appCheck = initializeAppCheck(app, {
  // get the site key from your environment variable, AppCheck_Recaptcha_SiteKey, or config file
  provider: new ReCaptchaV3Provider(import.meta.env.VITE_RECAPTCHA_SITE_KEY),
  // Set to true to automatically refresh tokens in the background
  isTokenAutoRefreshEnabled: true 
});

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

// Safely initialize Analytics (Prevents iOS Safari / Mobile browser crashes)
export let analytics: Analytics | null = null;

isSupported().then((supported) => {
  if (supported) {
    analytics = getAnalytics(app);
    setUserProperties(analytics, {
      app_version: APP_VERSION,
      build_number: BUILD_NUMBER,
    });
  }
}).catch((err) => {
  console.warn("Analytics not supported in this environment:", err);
});

export { logEvent, APP_VERSION as appVersion, app };
export default app;